<template>
  <div>
    <TerrorZoneNavBar @change-language="showNoTranslation=true"/>
    <div id="slot-top_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-top_banner" class="desktop-banner hoz-banner"/>
    <component v-bind:is="viewComponent" />
    <div id="slot-btm_mobile_banner" class="mobile-banner hoz-banner"/>
    <div id="slot-btm_banner" class="desktop-banner hoz-banner"/>
    <TerrorZoneFooter class="mt-4"/>
    <b-modal
      v-model="showNoTranslation"
      title="Translation Issue"
      hideHeaderClose
      ok-only
    >
      {{ $t('common.noTranslation') }}
    </b-modal>
  </div>
</template>

<script>
import TerrorZoneNavBar from './components/NavBar.vue'
import TerrorZoneFooter from './components/Footer.vue'
import Introduction from './components/blogs/Introduction.vue'
import MooMooFarm from './components/blogs/MooMooFarm.vue'
import Pit from './components/blogs/Pit.vue'
import HallsOfTheDead from './components/blogs/HallsOfTheDead.vue'
import Travincal from './components/blogs/Travincal.vue'
import StonyTomb from './components/blogs/StonyTomb.vue'
import FlayerJungle from './components/blogs/FlayerJungle.vue'
import ArcaneSanctuary from './components/blogs/ArcaneSanctuary.vue'
import Chaos from './components/blogs/Chaos.vue'
import WSK from './components/blogs/WSK.vue'
import MosaicAsn from './components/builds/MosaicAsn.vue'
import Hammerdin from './components/builds/Hammerdin.vue'
import NovaSor from './components/builds/NovaSor.vue'
import LightningSor from './components/builds/LightningSor.vue'
import SummonNec from './components/builds/SummonNec.vue'
import BowAmazon from './components/builds/BowAmazon.vue'
import FireclawsDru from './components/builds/FireclawsDru.vue'
import BerserkerBarb from './components/builds/BerserkerBarb.vue'
import LightningJavazon from './components/builds/LightningJavazon.vue'
import WindDru from './components/builds/WindDru.vue'
import { parseParameters } from '@/utils/common'

export default {
  components: {
    TerrorZoneNavBar,
    TerrorZoneFooter,
    Introduction,
  },

  data() {
    return {
      showNoTranslation: false,
    }
  },

  computed: {
    path () {
      return window.location.pathname;
    },

    blogKey () {
      const paramStr = window.location.search;
      if (paramStr?.length > 0) {
        const params = parseParameters(paramStr);
        if (params['zones']) {
          return params['zones']
        }
        if (params['build']) {
          return params['build']
        }
      }
      return null;
    },

    router () {
      return {
        // tz blogs
        'pit': Pit,
        'moo-moo-farm': MooMooFarm,
        'stony-tomb': StonyTomb,
        'halls-of-the-dead': HallsOfTheDead,
        'arcane-sanctuary': ArcaneSanctuary,
        'travincal': Travincal,
        'flayer-jungle': FlayerJungle,
        'chaos-sanctuary': Chaos,
        'wsk': WSK,
        // build blogs
        'mosaic-asn': MosaicAsn,
        'hammerdin': Hammerdin,
        'nova-sor': NovaSor,
        'lightning-sor': LightningSor,
        'summon-nec': SummonNec,
        'bow-ama': BowAmazon,
        'fireclaws-dru': FireclawsDru,
        'berserker-barb': BerserkerBarb,
        'lightning-javazon': LightningJavazon,
        'wind-dru': WindDru,
      }
    },

    viewComponent () {
      if (this.path === '/introduction' || !this.blogKey) {
        return Introduction
      }
      return this.router[this.blogKey] || Introduction
    }
  },
}
</script>

<style>
.blog-main-content {
  color: #fff;
  justify-content: space-around;
  max-width: 900px;
  margin: 40px auto;
  width: 70%;
}

.highlight {
  font-weight: bold;
}
.skills-tab {
  width: 100%;
  max-width: 500px;
}
.build-screenshot {
  width: 50%;
  margin: 40px auto;
}
@media (max-width: 1200px) {
  .build-screenshot {
    width: 100%;
  }
}
@media (max-width: 600px) {
  .blog-main-content {
    width: 90%;
  }
}
</style>